/* aa-cut-gate-share.js - ONE security check, not two.  14 Aug 2026.

   THE BUG THIS FIXES (measured on the live store, 14 Aug, angles page):
   this store runs TWO independent Cloudflare Turnstile gates for the very
   same cut engine.

     1. the PAGE-LEVEL gate, inline in layout/theme.liquid: caches its token
        in sessionStorage ('aa_cut_session'), survives navigation, warms
        itself on the customer's first interaction, 12s ceiling, and attaches
        the token to every /quote by patching window.fetch. Added 5 Aug for
        exactly this reason - its own comment records Turnstile costing
        9,843ms on every page view before that change.

     2. the SECTION gate, assets/aa-session.js: keeps its token in a plain JS
        variable, so it is COLD ON EVERY PAGE LOAD, and the collection tables
        wait for it before sending the first quote.

   They never share. So a customer who types their first cut size waits for a
   SECOND challenge while a perfectly good token sits in sessionStorage.
   Measured, same page, valid page-level token with 20 minutes left:

       window.AACut.ensureSession()  ->  16,675 ms

   and a warm run earlier the same afternoon -> 5,955 ms. Cloudflare gets
   slower the more challenges one browser asks for, which is why the second
   gate degrades as a customer works through a cut list. When it finally
   exceeds aa-session.js's 25s ceiling the quote fails, and the collection
   table then tells the customer "This cut list cannot be produced from the
   available stock lengths" - blaming their measurements for a security
   handshake that timed out.

   THE FIX: hand the section gate the page-level token. No second challenge.

   - a valid shared token exists  -> return it immediately (0ms)
   - none yet, page-level gate present -> return null and let the page-level
     gate mint one DURING the request (it caches it, and it already retries
     on 401). One challenge, not two.
   - no page-level gate at all (block deleted / other theme) -> fall through
     to the original behaviour, unchanged.

   Load AFTER aa-session.js. Safe to load anywhere; does nothing if AACut
   never appears. ASCII only, no dependencies.

   ROLLBACK: delete the one <script> line that loads this file. Nothing else
   references it. */
(function () {
  'use strict';
  var KEY = 'aa_cut_session';   /* the key layout/theme.liquid writes */
  var SKEW = 30000;             /* same 30s safety margin the page gate uses */

  function sharedToken() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (o && o.session && o.exp > Date.now() + SKEW) return o.session;
    } catch (e) {}
    return null;
  }

  function install() {
    if (!window.AACut || typeof window.AACut.ensureSession !== 'function') return false;
    if (window.AACut.aaShared) return true;
    var original = window.AACut.ensureSession;
    window.AACut.ensureSession = function (force) {
      var t = sharedToken();
      if (t) return Promise.resolve(t);
      /* No shared token yet. If the page-level gate is installed it will mint
         one during the request itself and cache it for the next page, so a
         second challenge here would be pure waste. */
      if (window.__aaSidPatched) return Promise.resolve(null);
      return original.call(window.AACut, force);
    };
    window.AACut.aaShared = 1;
    return true;
  }


  /* ---------------------------------------------------------------------
     THE BAR CUT TOOL NO LONGER NEEDS A SECURITY PASS AT ALL (14 Aug).

     The engine now lets mode:'plan-table' straight through - it is handed
     its stock lengths AND prices by the browser, so it returns nothing the
     page had not already printed (see the alucut gate-mode change). But the
     storefront still WAITED for a pass before sending: the inline block in
     layout/theme.liquid patches window.fetch and calls getSession() first.
     Measured on the live store after the engine change: the first quote of a
     visit still took 7,154 ms.

     So plan-table quotes are sent with XMLHttpRequest, which nothing on this
     store patches, and the reply is handed back as a real Response so every
     existing caller is unchanged. Everything else - offcuts, plate, rod,
     cart, all of it - goes through the normal patched fetch and keeps its
     pass.

     WHY NOT a fetch borrowed from a hidden iframe: tried first, and it
     recursed - "Maximum call stack size exceeded" on the live page (caught by
     measuring, not by reading). XHR has no realm or re-entry problem.

     Fail-safe: any non-2xx, or any transport error, falls back to the normal
     patched fetch, which mints a pass and retries. Slow, never broken. */
  function isPlanTable(init) {
    try {
      if (!init || typeof init.body !== 'string') return false;
      if (init.body.indexOf('plan-table') < 0) return false;      /* cheap reject */
      var b = JSON.parse(init.body);
      return !!(b && b.mode === 'plan-table');
    } catch (e) { return false; }
  }

  function xhrPost(url, init) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', url, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) {
          resolve(new Response(x.responseText, {
            status: x.status,
            headers: { 'Content-Type': 'application/json' }
          }));
        } else { reject(new Error('status ' + x.status)); }
      };
      x.onerror = function () { reject(new Error('network')); };
      x.ontimeout = function () { reject(new Error('timeout')); };
      x.timeout = 20000;
      x.send(init.body);
    });
  }

  function installFastPath() {
    if (window.aaFastQuote) return;
    var patched = window.fetch;
    if (typeof patched !== 'function') return;
    window.aaFastQuote = 1;
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      if (url.indexOf('alucut.allaluminium.workers.dev') >= 0 && url.indexOf('/quote') >= 0 && isPlanTable(init)) {
        return xhrPost(url, init).catch(function () {
          return patched.call(window, input, init);   /* exemption gone / blocked - do it the slow way */
        });
      }
      /* everything else: hand straight back. call(window, ...) on purpose -
         aa-session.js is 'use strict', so its bare fetch(...) would pass
         this === undefined and native fetch refuses that. */
      return patched.call(window, input, init);
    };
  }
  /* the theme block patches window.fetch inline; wrap whatever is there once
     the page has settled, and again on load in case it lands later. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installFastPath);
  } else {
    installFastPath();
  }
  window.addEventListener('load', installFastPath);


  /* ---------------------------------------------------------------------
     AND STOP RUNNING THE CHALLENGE ON PAGES THAT NO LONGER NEED IT.

     Measured on the live store, 14 Aug, after everything above shipped: the
     first cut size on a fresh page still took ~6.7 s. The trace says why -
     the quote was SENT at 8,453 ms and answered at 8,469 ms (16 ms). It was
     not the network. The security challenge was running, and it holds the
     main thread for several seconds while it fingerprints the browser
     (WebGPU probe, font decode - visible as its own console noise). The page
     is frozen, so the panel cannot even ask.

     On a bar collection page nothing needs a pass any more: the only tool is
     the cut table, and the engine lets its mode straight through. So on
     THOSE pages - and only those - hand the theme's warm-up a stub that
     declines instead of challenging. No challenge, no freeze.

     STRICTLY SCOPED. If the page carries any tool that genuinely still needs
     a pass - the plate/sheet modal, the project builder, the delivery quote -
     the stub is not installed and everything behaves exactly as before.

     ROLLBACK: delete this file's <script> line; the challenge returns. */
  function barTableOnly() {
    try {
      if (!document.querySelector('.aa-table-price')) return false;      /* not a bar table page */
      if (document.querySelector('.aa-cutm-overlay, .aa-pb, #qd')) return false;  /* something here still needs a pass */
      return true;
    } catch (e) { return false; }
  }
  function declineChallenge() {
    try {
      if (window.turnstile) return;            /* already loaded - leave it alone */
      if (!barTableOnly()) return;
      window.turnstile = {
        aaStub: 1,
        render: function (el, opts) {
          /* answer the way a browser that cannot be challenged answers, at
             once, so the caller gives up in microseconds instead of seconds */
          try { setTimeout(function () { if (opts && opts['error-callback']) opts['error-callback'](); }, 0); } catch (e) {}
          return 'aa-stub';
        },
        remove: function () {}, reset: function () {}, getResponse: function () { return null; }
      };
    } catch (e) {}
  }
  declineChallenge();

  /* aa-session.js is deferred, so it may not have run yet. Try now, then poll
     briefly, then give up quietly - never leave a timer running on a page that
     has no cut tool. */
  if (!install()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (install() || ++tries > 120) clearInterval(iv);
    }, 50);
  }
})();
